export default function Step1(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="32" cy="32" r="21.5" stroke="black" strokeWidth="3" />
            <path
                d="M24.7354 27.706C30.3236 26.9609 41.5001 27.4824 41.5001 35.5295C41.5001 43.5766 31.0687 44.0981 25.853 43.353"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path
                d="M30.3235 21L23.3452 28.1465C23.1539 28.3424 23.1557 28.6557 23.3494 28.8494L30 35.5"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    );
}
